import axios from "axios";

const API_BASE_URL = "/api";

export const paymentService = {
    // Process Click to Pay payment
    processClickToPay: async (paymentData) => {
        try {
            // Step 1: Initialize Click to Pay session
            const sessionResponse = await axios.post(`${API_BASE_URL}/payment/clicktopay/initiate`, {
                invoiceId: paymentData.invoiceId,
                amount: paymentData.amount,
                currency: paymentData.currency || "TND",
                companyId: paymentData.companyId
            });

            const { sessionId, clientToken } = sessionResponse.data;

            // Step 2: Initialize Click to Pay SDK (example - adjust to your provider)
            const ctpsdk = window.ClickToPay; // Assuming Click to Pay SDK is loaded globally

            if (!ctpsdk) {
                throw new Error("Click to Pay SDK not loaded");
            }

            const ctpInstance = ctpsdk({
                clientToken,
                environment: process.env.NODE_ENV === 'production' ? 'production' : 'sandbox'
            });

            // Step 3: Show Click to Pay UI
            const paymentResult = await new Promise((resolve, reject) => {
                ctpInstance.show({
                    sessionId,
                    amount: paymentData.amount,
                    currency: paymentData.currency || "EUR",
                    onSuccess: (result) => {
                        resolve({
                            success: true,
                            transactionId: result.transactionId,
                            paymentMethod: result.paymentMethod
                        });
                    },
                    onError: (error) => {
                        reject(new Error(error.message || "Payment failed"));
                    },
                    onCancel: () => {
                        resolve({ success: false, cancelled: true });
                    }
                });
            });

            if (paymentResult.success) {
                // Step 4: Confirm payment on backend
                await axios.post(`${API_BASE_URL}/payment/clicktopay/confirm`, {
                    sessionId,
                    transactionId: paymentResult.transactionId
                });

                return paymentResult;
            }

            return paymentResult;

        } catch (error) {
            console.error("Click to Pay error:", error);
            throw error;
        }
    },

    // Process regular card payment
    processCardPayment: async (paymentData) => {
        const response = await axios.post(`${API_BASE_URL}/payment/process`, {
            type: "card",
            invoiceId: paymentData.invoiceId,
            amount: paymentData.amount,
            companyId: paymentData.companyId
        });
        return response.data;
    },

    // Initiate bank transfer
    initiateBankTransfer: async (paymentData) => {
        const response = await axios.post(`${API_BASE_URL}/payment/bank-transfer`, {
            invoiceId: paymentData.invoiceId,
            amount: paymentData.amount,
            companyId: paymentData.companyId
        });
        return response.data;
    },

    // Save payment method for future use
    savePaymentMethod: async (paymentMethodData) => {
        const response = await axios.post(`${API_BASE_URL}/payment/save-method`, paymentMethodData);
        return response.data;
    },

    // Get saved payment methods
    getSavedPaymentMethods: async (companyId) => {
        const response = await axios.get(`${API_BASE_URL}/payment/methods/${companyId}`);
        return response.data;
    }
};
